import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import ResponsiveImage from 'components/Common/ResponsiveImage'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import { pluralizeToString } from 'lib/string/pluralize'
import { FullTrip } from 'tripPlanner/types/common'
import { formatShortDateRange } from 'tripPlanner/utils'

const BorderedResponsiveImage = styled(ResponsiveImage)`
  background-color: ${props => props.theme.palette.neutral.default.four};
  border-radius: ${(props) => props.theme.borderRadius.S};
  width: ${rem(36)};
  height: ${rem(36)};
  overflow: hidden;
  flex-shrink: 0;

  & img {
    width: 100%;
  }

  & source {
    width: 100%;
  }
`

const ImagePlaceholder = styled.div`
  width: ${rem(36)};
  height: ${rem(36)};
  background: ${props => props.theme.palette.neutral.default.four};
  border-radius: ${(props) => props.theme.borderRadius.S};
  flex-shrink: 0;
`

const NameAndDates = styled.div`
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  overflow: hidden;
`

type Props<
  T extends Pick<FullTrip, 'imageId' | 'name' | 'startDate' | 'endDate'>,
> = {
  trip: T | undefined
  dateFormat: 'dates' | 'length'
}

function ImmersiveHeaderTripDetails<
  T extends Pick<FullTrip, 'imageId' | 'name' | 'startDate' | 'endDate'>,
>({ trip, dateFormat }: Props<T>) {
  let tripDates = ''
  if (trip && trip.startDate && trip.endDate) {
    if (dateFormat === 'dates') {
      tripDates = formatShortDateRange(trip)
    } else {
      const days = trip.endDate.diff(trip.startDate, 'days') + 1
      tripDates = pluralizeToString('day', days)
    }
  }
  return (
    <>
      {trip?.imageId && (
        <BorderedResponsiveImage
          id={trip.imageId}
          aspectRatio="1"
          width="48px"
        />
      )}
      {!trip?.imageId && <ImagePlaceholder />}
      <NameAndDates>
        <Heading variant="heading6" wrap="truncate">
          {trip?.name}
        </Heading>
        <Caption variant="medium" weight="normal" wrap="truncate">
          {tripDates}
        </Caption>
      </NameAndDates>
    </>
  )
}

export default ImmersiveHeaderTripDetails
